const REDEMPTION_FORM_TYPE_IDS = {
  LOGIN: 1,
  REGISTER: 2,
};

export default REDEMPTION_FORM_TYPE_IDS;
